<template>
  <div class="drawer-case">
    <el-drawer
      class="dialog"
      :title="title"
      :top="top"
      :visible.sync="dialogVisible"
      :wrapperClosable="wrapperClosable"
      :size="dialogWidth"
      :before-close="handleClose"
      ref="dialog"
      :direction="direction"
      :close-on-click-modal="closeOnModal"
      :show-close="hasClose"
      :append-to-body="isappendtobody"
    >
      <div class="custom-drawer-box">
        <slot></slot>
      </div>

      <div class="drawer-footer" v-if="hasFooter">
        <el-button class="grayBtn" @click="cancel">{{
          cancelBtnTxt
        }}</el-button>

        <el-button
          type="primary"
          class="saveBtn1"
          :class="isSubmit ? 'isSubmit' : ''"
          @click="save"
          v-if="isSave"
          :loading="loading"
          :disabled="loading"
          >{{ saveBtnTxt }}</el-button
        >
        <el-button
          type="primary"
          class="saveBtn"
          v-if="isSubmit"
          @click="submit"
          :loading="loading"
          :disabled="loading"
          >{{ submitBtnTxt }}</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "Drawer",
  props: {
    //父组件传的显示/隐藏指针
    top: {
      type: String,
      required: false,
      default: "10vh",
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: "rtl",
    },
    //是否有右上角关闭
    hasClose: {
      type: Boolean,
      default: true,
    },
    wrapperClosable: {
      type: Boolean,
      default: false,
    },
    //弹窗宽度
    dialogWidth: {
      type: String,
      required: false,
      default: "6rem",
    },
    // //弹框的marginTop
    // dialogTop: {
    //   type: String,
    //   required: false,
    //   default: "15vh",
    // },
    //弹窗标题文字
    title: {
      type: [String, Number],
      required: false,
      default: "标题",
    },
    //标题背景颜色
    titleBgColor: {
      type: String,
      required: false,
      default: "#fff",
    },
    //标题高度
    titleHeight: {
      type: String,
      required: false,
      default: "0.65rem",
    },

    //标题字体大小
    titleFontSize: {
      type: String,
      required: false,
      default: "0.16rem",
    },
    //标题字颜色
    titleColor: {
      type: String,
      required: false,
      default: "#000000",
    },
    //取消按钮的文字
    cancelBtnTxt: {
      type: String,
      required: false,
      default: "取消",
    },
    //确定按钮的文字
    saveBtnTxt: {
      type: String,
      required: false,
      default: "保存",
    },
    // 提交按钮的文字
    submitBtnTxt: {
      type: String,
      required: false,
      default: "提交",
    },
    //是否有footer
    hasFooter: {
      type: Boolean,
      default: true,
    },
    //遮罩层是否插入至了body元素上
    isappendtobody: {
      type: Boolean,
      default: true,
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
    isBold: {
      type: String,
      default: "bold",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    closeOnModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // closeOnModal: false,
      loading: false,
    };
  },
  watch: {},
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
      // this.$emit("dialogShowChange", false);
    },
    handleClose(done) {
      this.$emit("resetPopupData");
    },
    cancel() {
      this.$emit("resetPopupData");
    },
    save() {
      this.$emit("submitPopupData");
    },
    submit() {
      this.$emit("submitBtnPopupData");
    },
  },
  computed: {
    //本组件的显示/隐藏指针
    dialogVisible: {
      get() {
        return this.dialogShow;
      },
      set(val) {
        // 当dialogVisible改变的时候，触发父组件的 updateVisible方法，更改传入子组件的dialogShow的值
        this.$emit("updateVisible", val);
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.titleHeight)
        document
          .querySelector(".dialog")
          .style.setProperty("--titleheight", this.titleHeight);
      if (this.titleBgColor)
        document
          .querySelector(".dialog")
          .style.setProperty("--titlebg", this.titleBgColor);
      if (this.titleFontSize)
        document
          .querySelector(".dialog")
          .style.setProperty("--titlesize", this.titleFontSize);
      if (this.titleColor)
        document
          .querySelector(".dialog")
          .style.setProperty("--titlecolor", this.titleColor);
    });
  },
};
</script>

<style lang="scss">
.drawer-case {
  font-size: 0.16rem;
  line-height: 1.4;
  .el-drawer {
    display: flex;
    flex-direction: column;
    .el-drawer__header {
      flex-shrink: 0;
      div {
        font-size: 0.16rem !important;
        color: #000000 !important;
        font-weight: normal !important;
      }
    }
    .el-drawer__body {
      flex: 1;
      padding: 0 !important;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .custom-drawer-box {
        flex: 1;
        overflow-y: auto;
        padding: 0.2rem 0.2rem 0 !important;
      }
    }
    .el-drawer__header {
      margin-bottom: 0 !important;
      padding-bottom: 0.12rem !important;
      padding-top: 0.12rem !important;
      background: #f7f8fb;
      color: #000000;
      font-size: 0.16rem;
      font-family: pm serif;
    }
  }
  .drawer-footer {
    //width: calc(100% - 2.12rem);
    flex-shrink: 0;
    //position: sticky;
    //right: 0px;
    //bottom: 0px;
    height: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: right;
    background-color: #ffffff;
    //padding-top: 0.22rem;
    border-top: 0.01rem solid #dce5f5;
    padding-right: 0.2rem;
    .saveBtn {
      padding: 0 0.14rem;
      height: 0.32rem;
      background: #0090ff;
      opacity: 1;
      border-radius: 0.08rem;
    }
    .saveBtn1 {
      padding: 0 0.14rem;
      height: 0.32rem;
      background: #1269ff;
      color: #ffffff;
      border: 1px solid #0090ff;
      opacity: 1;
      border-radius: 0.08rem;
    }
    /* 确定按钮 */
    .el-button--primary {
      // background-color: var(--primaryColor, #0090FF);
      border: 1px solid var(--primaryColor, #0090ff);
    }
    .grayBtn {
      padding: 0 0.14rem;
      height: 0.32rem;
      background-color: #dce5f5;
      color: #434343;
      opacity: 1;
      border-radius: 0.08rem;
    }
  }
}
</style>
